export default __webpack_public_path__ + "static/media/slide1.15f6a306.jpg";